
































import OlbIcon from '../icon/icon.vue';
import { defineComponent, onMounted, reactive, ref } from '@vue/composition-api';

export default defineComponent({
	components: { OlbIcon },
	props: {
		accId: String,
		isInitiallyOpen: {
			type: Boolean,
			default: false,
		},
	},
	setup(props, root) {
		const state = reactive({
			isActive: props.isInitiallyOpen,
			isLight: (root.parent as any).light,
		});
		const accContent = ref<HTMLDivElement | null>(null);

		function selectAccItem() {
			// toggle accordion item
			state.isActive = !state.isActive;

			// close all other accordion items
			root.parent?.$children.forEach((accItem: any) => {
				if (accItem.accId !== props.accId) {
					accItem.state.isActive = false;
				}
			});
		}

		function enterTransition(el: HTMLElement) {
			el.style.height = el.scrollHeight + 'px';
		}

		function afterLeaveTransition(el: HTMLElement) {
			el.style.height = '';
		}

		/**
		 * Returns the hash part of the url without the #
		 */
		function getHashWithoutHashtag() {
			return window.location.hash.substring(1);
		}

		/**
		 * Returns true if the hash contains a slash (/) on position 1.
		 * Such client-side hashes are used in the NGB aka FB6 (angular application).
		 */
		function isClientSideHash(hash: string) {
			return hash.indexOf('/') === 1;
		}

		/**
		 * Select the accordion item which corresponds to the hash in the url.
		 */
		function selectAccItemViaHash() {
			const hash = getHashWithoutHashtag();
			if (!hash || isClientSideHash(hash)) {
				return;
			}

			// activate the accordion item if it matches the hash
			// and it is not already activated
			if (props.accId === hash && !state.isActive) {
				selectAccItem();
			}
		}

		function hashChangeHandler() {
			selectAccItemViaHash();
		}
		window.addEventListener('hashchange', hashChangeHandler);

		onMounted(() => {
			selectAccItemViaHash();
		});

		return {
			state,
			enterTransition,
			afterLeaveTransition,
			selectAccItem,
			accContent,
		};
	},
});
